import axiosInstance from '../variables/api/axiosInstance';

/**
 * Deux modes de récupération des organismes :
 *  - getAllOrganismes  : liste complète (vue groupée bureaux/compagnies, sélecteurs).
 *  - getOrganismesPage : page filtrée côté serveur (type, code pays, recherche).
 */

// Liste complète des organismes actifs.
export const getAllOrganismes = async () => {
  const res = await axiosInstance.get('/v1/organismes');
  return res.data?.data || [];
};

// Page d'organismes avec filtres optionnels.
// Le backend n'expose pas de liste paginée : on récupère les organismes du type
// demandé via /by-type (endpoint réel), puis on filtre (recherche + pays) et
// on pagine côté client. Le jeu de données par type reste petit (quelques dizaines).
export const getOrganismesPage = async ({ page = 0, size = 20, type, codePays, search } = {}) => {
  const params = new URLSearchParams();
  if (type) params.append('typeOrganisme', type);
  const res = await axiosInstance.get(`/v1/organismes/by-type?${params}`);
  let liste = res.data?.data || [];

  if (search) {
    const q = search.toLowerCase();
    liste = liste.filter((o) =>
      o.raisonSociale?.toLowerCase().includes(q) || o.code?.toLowerCase().includes(q));
  }
  if (codePays) {
    liste = liste.filter((o) => o.codePays === codePays || o.codePaysBCB === codePays);
  }

  const total = liste.length;
  const start = page * size;
  return {
    items: liste.slice(start, start + size),
    total,
    page,
    size,
  };
};
